"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROITourModal = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_react_1 = require("mobx-react");
exports.ROITourModal = (0, mobx_react_1.observer)(function (props) { return (react_1.default.createElement("div", { className: "roi-tour-modal-container" },
    react_1.default.createElement(kaleidoscope_1.Card, { className: "roi-tour-modal" },
        react_1.default.createElement("div", { className: "roi-tour-modal-icon" },
            react_1.default.createElement(icons_1.WidgetRoi, { size: icons_1.IconSize.Large })),
        react_1.default.createElement("div", { className: "roi-tour-modal-heading" }, "Welcome to the ROI Calculator"),
        react_1.default.createElement("div", { className: "roi-tour-modal-body" }, "Would you like to take a tour to learn how it works or skip and jump straight in?"),
        react_1.default.createElement("div", { className: "roi-tour-modal-buttons" },
            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: props.onCancel }, "Skip tour"),
            react_1.default.createElement(kaleidoscope_1.Button, { onClick: props.onConfirm }, "Start tour"))))); });
